import { DataSourceSetupComposite } from "./DataSourceSetupComposite";
import { Alert, Text } from "@theorgchartdev/storybook";
import * as StateLib from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";

export const PaylocitySetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  let wsMgr = StateLib.GetWSMgr();
  let inputDisabled = false;
  if ((config.source == "paylocity") & !wsMgr?.fAdminLogin) inputDisabled = true;

  return (
    <>
      {inputDisabled && (
        <Alert severity={"info"} withBorder showIcon style={{ marginTop: "16px" }}>
          <Text size={"small"} style={{ color: "inherit", lineHeight: 1.5 }}>
            {appstr("changePaylocity")}
            <a href="https://theorgchart.zendesk.com/">OrgChart Support</a>
          </Text>
        </Alert>
      )}
      <DataSourceSetupComposite
        config={config}
        onChange={onChange}
        index={index}
        chartConfig={chartConfig}
        showInputControls={!inputDisabled}
        showConfiguration={importType !== "import"}
        showLoadHeaders={importType !== "import"}
        importType={importType}
      />
    </>
  );
};
